import * as Yup from 'yup'

const PresentationFormValidations = () => {
  return Yup.object().shape({
    name: Yup.string()
      .min(3, 'Minimum 3 symbols')
      .max(50, 'Maximum 150 symbols')
      .required('Title is required'),
    link: Yup.string()
      .min(3, 'Minimum 3 symbols')
      .max(50, 'Maximum 150 symbols')
      .required('Title is required')
  })
}

export { PresentationFormValidations }
